const TOOL_MENU_DIMENSIONS = {
    sticky: {width: 272, height: 292},
    connector: {width: 232, height: 188},
};

/**
 * Positionne les menus d'outils au niveau du viewport afin qu'ils ne soient
 * jamais rognés par la barre horizontale du Tableau Blanc.
 */
export const getFloatingToolMenuPosition = ({
    rect,
    menuName,
    viewportWidth,
    viewportHeight,
    margin = 12,
    gap = 8,
}) => {
    const dimensions = TOOL_MENU_DIMENSIONS[menuName] || TOOL_MENU_DIMENSIONS.sticky;
    const width = Math.min(dimensions.width, Math.max(0, viewportWidth - margin * 2));
    const height = dimensions.height;
    const availableBelow = viewportHeight - rect.bottom - gap - margin;
    const availableAbove = rect.top - gap - margin;
    const opensAbove = availableBelow < height && availableAbove > availableBelow;

    return {
        width,
        left: Math.max(margin, Math.min(rect.left, viewportWidth - width - margin)),
        top: opensAbove
            ? Math.max(margin, rect.top - height - gap)
            : Math.min(viewportHeight - margin - Math.min(height, availableBelow), rect.bottom + gap),
    };
};

export default getFloatingToolMenuPosition;
